module.exports = __webpack_public_path__ + "static/media/rightArrow.2480d4b3.svg";